import type { ReactNode } from 'react';

/** Inbox art: notifications grouped under their jobs. Under 1 KB. */
export function InboxArt({ width = 220 }: { width?: number }): ReactNode {
  return (
    <svg
      viewBox="0 0 220 96"
      width={width}
      height={(width * 96) / 220}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="40" y="14" width="140" height="68" rx="8" />
      <path d="M40 34h140" opacity="0.4" />
      <path d="M52 24h40" />
      <circle cx="166" cy="24" r="4" fill="var(--paige-accent)" stroke="none" />
      <path d="M52 46h56M52 58h72M52 70h48" opacity="0.6" />
      <circle cx="46" cy="46" r="2" fill="currentColor" stroke="none" />
      <circle cx="46" cy="58" r="2" fill="currentColor" stroke="none" />
      <path d="M20 40c-4 6-4 16 0 22M200 40c4 6 4 16 0 22" opacity="0.5" />
    </svg>
  );
}
